import React from 'react';
import { createSlug } from '../../util/urlHelpers';
import { FormattedMessage } from '../../util/reactIntl';
import { IconProfileCard, NamedLink, ResponsiveImage } from '..';

import {
  PRODUCT_CLICKED_EVENT,
  algoliaEventTrackFn,
  clickedObjectIDsMethodName
} from '../../containers/AlgoliaSearchPage/AlgoliaEvents';

import { LISTING_CARD_2X } from '../../util/types';

import css from './AlogoliaSearchCard.module.css';
import { convertCardImageURLwebp, transformCloudinaryUrl } from '../../util/data';



const AlogoliaSearchCard = props => {
  const { hit, currentUser, algoliaState, currentPage, isMobileLayout } = props;
  const { title = "T", objectID, price, __queryID, __position, image_url, publicData, state } = hit || {};
  const { categoryName, subCategoryName, condition } = publicData || {};
  const desktopTransform = "w_500,h_500,c_fit,f_auto,q_auto";
  const mobileTransform = "w_250,h_250,c_fit,f_auto,q_auto";

  const variants = [LISTING_CARD_2X];
  const image = image_url ? {
    type: "image",
    attributes: {
      variants: {
        "listing-card-2x": {
          width: 800,
          height: 533,
          url: isMobileLayout ? transformCloudinaryUrl(convertCardImageURLwebp(image_url), mobileTransform) : transformCloudinaryUrl(convertCardImageURLwebp(image_url), desktopTransform)
        },
        "scaled-medium": {
          width: 750,
          height: 750,
          url: isMobileLayout ? transformCloudinaryUrl(convertCardImageURLwebp(image_url), mobileTransform) : transformCloudinaryUrl(convertCardImageURLwebp(image_url), desktopTransform)
        }
      }
    }
  } : image_url;

  const namedLinkTo = currentUser?.id?.uuid ? {
    to: {
      search: `?aQueryId=${__queryID}`
    }
  } : {};


  //  <img
  //                   alt="We're having trouble loading product images. Please try again later."
  //                   src={
  //                     isMobileLayout
  //                       ? transformCloudinaryUrl(convertCardImageURLwebp(image_url), mobileTransform)
  //                       : transformCloudinaryUrl(convertCardImageURLwebp(image_url), desktopTransform)
  //                   }
  //                   loading="lazy"
  //                 />

  // <ResponsiveImage
  //               alt={"We're having trouble loading product images. Please try again later."}
  //               image={image}
  //               variants={variants}
  //             />


  return (
    <div className={css.root} key={objectID} onClick={(e) => {
      try {
        e.preventDefault();
        if (currentUser?.id?.uuid) {
          const userID = currentUser.id.uuid;
          algoliaEventTrackFn(clickedObjectIDsMethodName, {
            index: process.env.REACT_APP_ALGOLIA_LISTING_INDEX,
            eventName: PRODUCT_CLICKED_EVENT,
            queryID: __queryID,
            userToken: userID,
            objectIDs: [objectID],
            positions: [__position],
            eventData: {
              listingID: objectID,
              queryID: __queryID,
              userID,
              timestamp: new Date().toISOString(),
            }
          });
        };
      } catch (e) {
        console.log(e, '&&& &&& => e');
      }
    }} >
      <NamedLink
        name="ListingPage"
        params={{
          id: objectID,
          slug: createSlug(title),
          category: createSlug(categoryName || "category"),
          subCategory: createSlug(subCategoryName || "sub-category")
        }}
        className={css.link}
        isSearchPage={true}
        {...namedLinkTo}
      >
        <div className={css.container}>
          <div className={css.imageBox}>
            {
              image_url ?
                <img
                  alt="We're having trouble loading product images. Please try again later."
                  src={
                    isMobileLayout
                      ? transformCloudinaryUrl(convertCardImageURLwebp(image_url), mobileTransform)
                      : transformCloudinaryUrl(convertCardImageURLwebp(image_url), desktopTransform)
                  }
                  // src={convertCardImageURLwebp(image_url)}
                  loading="lazy"
                />
                : <div className={css.noImageIcon}><IconProfileCard type="no_image" /><FormattedMessage id="ResponsiveImage.noImage" /></div>
            }
          </div>
          <div className={css.imageDetails}>
            {isMobileLayout ?  null : <p className={state == "closed" ? css.storeClosedName : css.storeName}>{state == "closed" ? <FormattedMessage id="ManageListingCard.thislistingIOsClosed" /> : `${categoryName} | ${subCategoryName}`}</p>}
            <p className={isMobileLayout ? css.titleMobile : css.title}>{title}</p>
            <p className={isMobileLayout ? css.priceMobile : css.price}>{price ? `$${price.toFixed(2)}` : null}<b>USD</b></p>
          </div>
          {condition ? <div className={css.condition}>{condition}</div> : null}
        </div>
      </NamedLink>
    </div>
  );
};

export default AlogoliaSearchCard;
